import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import msalInstance, { initializeMsal } from "../msalInstance";
import { loginRequest } from "../msalConfig";
import LoadingSpinner from "./LoadingSpinner";
import Logo from '../assets/bass-pro.png';

const Login = () => {
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(state);

  useEffect(() => {
    // Handle any pending redirect on the login page (e.g., after logout)
    const handleRedirect = async () => {
      try {
        await initializeMsal;
        await msalInstance.handleRedirectPromise();
      } catch (error) {
        console.error('Error handling redirect on login page:', error);
      }
    };

    handleRedirect();
  }, []);

  const handleLogin = async () => {
    setIsLoading(true);
    setErrorMessage('');

    try {
      // Ensure MSAL is initialized before calling any APIs
      await initializeMsal;

      // Check if there's already an interaction in progress
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length > 0) {
        // User is already logged in, redirect to callback
        window.location.href = '/callback';
        return;
      }

      // MSAL will redirect to Azure AD login page and handle the full OIDC flow
      await msalInstance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login error:', error);
      setErrorMessage(error.message || 'Login failed. Please try again.');
      setIsLoading(false);
    }
  };

  return (
    <div className="main-container">
      <img src={Logo} alt="logo" data-cy="logo" style={{ maxWidth: '300px' }} />

      <LoadingSpinner showWhen={isLoading} />

      {!isLoading &&
        <div className="button"
          onClick={handleLogin}>
          Login to WS50
        </div>
      }
      {errorMessage?.length > 0 && <div className="text-red-500">{errorMessage}</div>}
    </div>
  );
};

export default Login;
